import React from 'react';
import { Modal } from 'react-bootstrap';
import { backendUrl } from '../../constants';

// Helper to render field value based on type
function renderFieldValue(field) {
    const rawValue = field.value;

    if (rawValue === undefined || rawValue === null || rawValue === '') {
        return '-';
    }

    const valueStr = String(rawValue);

    switch (field.type) {
        case 'textarea':
            return (
                <div
                    className="text-break"
                    style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
                >
                    {valueStr}
                </div>
            );

        case 'number':
            return <span>{valueStr}</span>;

        case 'email':
            return (
                <a href={`mailto:${valueStr}`} rel="noreferrer">
                    {valueStr}
                </a>
            );

        case 'date': {
            const d = new Date(valueStr);
            const isValidDate = !isNaN(d.getTime());
            return <span>{isValidDate ? d.toLocaleDateString() : valueStr}</span>;
        }

        case 'select': {
            // If options are present, show label instead of raw value
            if (Array.isArray(field.options) && field.options.length > 0) {
                const matched = field.options.find((opt) => opt.value === rawValue);
                if (matched) {
                    return (
                        <span>
                            {matched.label}{' '}
                            <small className="text-muted">({matched.value})</small>
                        </span>
                    );
                }
            }
            return <span>{valueStr}</span>;
        }

        case 'file': {
            const url = backendUrl + valueStr;
            // strip query string for extension check
            const cleanUrl = url.split('?')[0].toLowerCase();
            const isImage = /\.(jpe?g|png|gif|webp|svg)$/i.test(cleanUrl);

            if (isImage) {
                return (
                    <div>
                        <img
                            src={url}
                            alt={field.label || 'Uploaded file'}
                            style={{
                                maxWidth: '140px',
                                maxHeight: '140px',
                                objectFit: 'cover',
                                borderRadius: 4,
                                border: '1px solid #eee',
                            }}
                        />
                        <div className="mt-1">
                            <a href={url} target="_blank" rel="noreferrer">
                                Open full image
                            </a>
                        </div>
                    </div>
                );
            }

            return (
                <a href={url} target="_blank" rel="noreferrer">
                    Download file
                </a>
            );
        }

        case 'text':
        default:
            return <span>{valueStr}</span>;
    }
}

export default function ViewDetails({ show, onClose, pageItem }) {
    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>Todo details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {pageItem ? (
                    <>
                        {/* Basic info */}
                        <div className="mb-3">
                            <h5 className="mb-1">{pageItem.title}</h5>
                            <div className="text-muted small">
                                {pageItem?.user?.first_name} {pageItem?.user?.last_name}
                                {pageItem?.user?.email ? ` · ${pageItem.user.email}` : ''}
                            </div>
                            <div className="mt-2">
                                <span className="badge bg-secondary">
                                    {pageItem?.status?.toUpperCase() || '-'}
                                </span>
                            </div>
                        </div>

                        {/* Fields (if stored) */}
                        {Array.isArray(pageItem.fields) && pageItem.fields.length > 0 && (
                            <div className="todo-detail-fields">
                                <h6 className="mb-2">Fields</h6>
                                {pageItem.fields.map((field, idx) => (
                                    <div
                                        key={field.key || idx}
                                        className="d-flex flex-column flex-md-row justify-content-between align-items-md-center border rounded p-2 mb-2"
                                    >
                                        <div className="mb-1 mb-md-0">
                                            <div className="fw-semibold">
                                                {field.label}{' '}
                                                {field.required ? (
                                                    <span className="text-danger">*</span>
                                                ) : null}
                                            </div>
                                            <div className="text-muted small">
                                                Key: {field.key} · Type: {field.type}
                                            </div>
                                            {field.placeholder && (
                                                <div className="text-muted small">
                                                    Placeholder: {field.placeholder}
                                                </div>
                                            )}
                                        </div>

                                        <div className="text-md-end mt-2 mt-md-0">
                                            <div className="small text-muted mb-1">
                                                Status: {field.status || 'pending'}
                                            </div>
                                            <div className="fw-normal">
                                                Value:{' '}
                                                {renderFieldValue(field)}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* If no fields exist */}
                        {(!pageItem.fields || pageItem.fields.length === 0) && (
                            <div className="text-muted small">
                                No field data available for this todo.
                            </div>
                        )}
                    </>
                ) : (
                    <div className="text-center text-muted">No data to display.</div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button onClick={onClose} className="btn save-btn deny">
                    Close
                </button>
            </Modal.Footer>
        </Modal>
    );
}
